import { cn } from "@omni/utils/styles";

import { DividerComponentProps } from "./divider.props";
import { divider } from "./divider.style";

export const Divider = ({ className, marginTop }: DividerComponentProps) => {
    return (
        <div className={cn("tw:block tw:w-full", className)}>
            <div className={divider({ marginTop })} />
        </div>
    );
};
